import React , { useState , useEffect} from 'react';
import {Link} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import {ReactComponent as CopyrightSvg} from '../assets/svgs/copyright.svg';
import EnglishLongLogo from '../assets/logos/english-long-logo.jpg';
import GreekLongLogo from '../assets/logos/greek-long-logo.jpg';
import {ReactComponent as FacebookSVG} from '../assets/svgs/facebook-svg.svg'
import {ReactComponent as InstagramSVG} from '../assets/svgs/instagram-svg.svg'
import {ReactComponent as LinkedInSVG} from '../assets/svgs/linked-in.svg'
import {ReactComponent as TikTokSVG} from '../assets/svgs/tik-tok.svg'
import {ReactComponent as YouTubeSVG} from '../assets/svgs/youtube.svg'

const FooterContainer = styled.div`
   display: flex;
   justify-content: center;
   align-items: center;
   background-color: white;
   padding: 50px 100px;
   width:100%;
//   height: 300px;
@media (max-width: 768px) {
  flex-direction:column;
   text-align:center;
   justify-content:center;
   align-items:center;
   gap:20px;
   padding: 5px 50px;
  }
`;

const Columns = styled.div`
   display: flex;
   align-items: flex-start;
`;

const LogoCopyrightColumn = styled.div`
  display:flex;
  flex-direction: column;
    @media (max-width: 768px) {
      margin-bottom:30px;
    
  }
`;

const Copyright = styled.div`
    color:  #385963; 
    display:flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    svg{
      height: 15px;
      width: 15px;
      margin-right: 2px;
    }
    @media (max-width: 768px) {
     font-size:12px;
     }
`;

const Logo = styled.img`
  height: 300px;
  width: 350px;
    @media (max-width: 768px) {
       height: 180px;
       width: 100%;
  }
`;


const NavTabs = styled("ul")`
  display:flex;
  flex-direction: column;
  list-style: none;
  padding:0;
  font-size: 15px;

  & > li {
      margin: 5px 0px;

    a {
        text-decoration: none;
        color: #385963; 
       
        /* Add hover effect */
        &:hover {
          color: #91abb3 ; 
          transition:  0.4s;
        }
      }

  & > li:last-of-type {
    margin-right: 0;
  }

  @media (max-width: 768px) {
      font-size:10px;
  }
`;

const Column = styled.div`
   display:flex;
   flex-direction: column;
   align-items: left;
   margin-left: 70px;

   @media (max-width: 768px) {
   margin-left: 50px;
   font-size:14px;
   :first-of-type {
    margin-left: 0;
  }
  }
`;

const Title = styled.div`
   color: #385963; 
   font-weight: 500;
`;

const SocialMediaIcons = styled.div`
 display:flex;
 margin-top: 15px;
 justify-content: left;
 align-items:center;
 gap:10px;

 svg{
    height: 30px;
    width: 30px;
 }

 & > svg:last-of-type {
    margin-left: 5px;
    height:29px;
    width: 29px;
  }

   @media (max-width: 768px) {
    svg{
     height: 20px;
     width: 20px;
    }
  }
`;



const Footer = () => {

    const { i18n } = useTranslation();
    const currentLanguage = i18n.language;

      const [activeLink, setActiveLink] = useState('/'); 
      const [userType, setUserType] = useState("");

      useEffect(() => {
        const type =  sessionStorage.getItem("userRole");
        setUserType(type);
      }, []);


  return (
    <FooterContainer>

       <LogoCopyrightColumn>
        {currentLanguage=== 'en'? 
          <Logo src={EnglishLongLogo} /> 
          : 
          <Logo src={GreekLongLogo}/>
         }
          {/* <Copyright> 
               <CopyrightSvg />
               {i18n.t('copyrightText')}
          </Copyright> */}
       </LogoCopyrightColumn>
     <Columns>
        <Column>
            <Title>{i18n.t('olympusRiviera')}</Title>
           {userType ==="admin" ? 
              <NavTabs>  
                   <li>
                        <Link to="/admin/about-pieria" 
                         onClick={() => setActiveLink('/admin-about-pieria')}
                        //  style={{ color: activeLink === '/event-calendar' ? '#91abb3' : '#385963' }}
                        >
                            {i18n.t('aboutPieria')}
                        </Link>
                    </li>
                     <li>
                         <Link to="/admin/all-categories-admin" 
                          onClick={() => setActiveLink('/all-categories-admin')}
                         //  style={{ color: activeLink === '/event-calendar' ? '#91abb3' : '#385963' }}
                         >
                             {i18n.t('allCategories')}
                         </Link>
                     </li>
                     <li>
                         <Link to="/admin/users" 
                          onClick={() => setActiveLink('/admin/users')}
                         //  style={{ color: activeLink === '/event-calendar' ? '#91abb3' : '#385963' }}
                         >
                             {i18n.t('registeredUsers')}
                         </Link>
                     </li>
           
                     <li>
                         <Link to="/admin/providers" 
                          onClick={() => setActiveLink('/admin/providers')}
                         //  style={{ color: activeLink === '/event-calendar' ? '#91abb3' : '#385963' }}
                         >
                             {i18n.t('providers')}
                         </Link>
                     </li>
           
                     <li>
                         <Link to="/admin/destinations" 
                          onClick={() => setActiveLink('/admin/destinations')}
                         //  style={{ color: activeLink === '/event-calendar' ? '#91abb3' : '#385963' }}
                         >
                             {i18n.t('destinations')}
                         </Link>
                     </li>
           
                     <li>
                         <Link to="/admin/experiences" 
                          onClick={() => setActiveLink('/admin/experiences')}
                         //  style={{ color: activeLink === '/event-calendar' ? '#91abb3' : '#385963' }}
                         >
                             {i18n.t('experiences')}
                         </Link>
                     </li>
           
                     <li>
                         <Link to="/admin/events" 
                          onClick={() => setActiveLink('/admin/events')}
                         //  style={{ color: activeLink === '/event-calendar' ? '#91abb3' : '#385963' }}
                         >
                             {i18n.t('events')}
                         </Link>
                     </li>
           
                     <li>
                         <Link to="/admin/amenities" 
                          onClick={() => setActiveLink('/admin/amenities')}
                         //  style={{ color: activeLink === '/event-calendar' ? '#91abb3' : '#385963' }}
                         >
                             {i18n.t('amenities')}
                         </Link>
                     </li>
           
                     <li>
                         <Link to="/admin/requests" 
                          onClick={() => setActiveLink('/admin/requests')}
                         //  style={{ color: activeLink === '/event-calendar' ? '#91abb3' : '#385963' }}
                         >
                             {i18n.t('requests')}
                         </Link>
                     </li>
             </NavTabs>
           
           :
           <NavTabs>
                {/* <li>
                    <Link to="/destinations" onClick={() => setActiveLink('/destinations')}>
                    {i18n.t('destinations')}
                    </Link>
                </li> */}
                 <li>
                    <Link to="/" onClick={() => setActiveLink('/')}>
                    {i18n.t('aboutPieria')}
                    </Link>
                </li>
                <li>
                    <Link to="/destinations" onClick={() => setActiveLink('/destinations')}>
                    {i18n.t('destinations')}
                    </Link>
                </li>
                <li>
                    <Link to="/" onClick={() => setActiveLink('/')}>
                    {i18n.t('amenities')}
                    </Link>
                </li>
                <li>
                    <Link to="/experiences" onClick={() => setActiveLink('/experiences')}>
                    {i18n.t('experiences')}
                    </Link>
                </li>
                <li>
                    <Link  to="/plan-your-trip" onClick={() => setActiveLink('/plan-your-trip')}>
                    {i18n.t('planYourTrip')}
                    </Link>
                </li>
                <li>
                    <Link to="/event-calendar" onClick={() => setActiveLink('/event-calendar')}>
                        {i18n.t('calendar')}
                    </Link>
                </li>
                <li>
                    <Link to="/register-signIn" onClick={() => setActiveLink('/register-signIn')} >
                        {i18n.t('registerSignIn')}
                    </Link>
                </li>
            </NavTabs>
           } 
        </Column>

        <Column>
            <Title>{i18n.t('about')}</Title>
            <NavTabs>
                <li>
                    <Link to="/terms-of-use" onClick={() => setActiveLink('/terms-of-use')}>
                    {i18n.t('termsOfUse')}
                    </Link>
                </li>
                <li>
                    <Link  to="/privacy-policy" onClick={() => setActiveLink('/privacy-policy')}>
                    {i18n.t('privacyPolicy')} & {i18n.t('cookiePolicy')}
                    </Link>
                </li>
                <li>
                    <Link to="/delete-account" onClick={() => setActiveLink('/delete-account')}>
                        {i18n.t('deleteAccount')}
                    </Link>
                </li>
                <li>
                    <Link to="/contact-information" onClick={() => setActiveLink('/contact-information')}>
                        {i18n.t('contact')}
                    </Link>
                </li>
            </NavTabs>
         </Column>

        <Column>
           <Title>{i18n.t('followUs')}</Title>
           <SocialMediaIcons>
                  <Link 
                      to="https://www.facebook.com/olympusrivieragreece" 
                      target="_blank" 
                      rel="noopener noreferrer">
                    <FacebookSVG   />
                  </Link>

                <Link 
                  to="https://www.instagram.com/olympusrivieragreece/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >    
                  <InstagramSVG />
                </Link>
                <Link 
                  to="https://www.linkedin.com/company/olympus-riviera-greece/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >    
                  <LinkedInSVG />
                </Link>
                <Link 
                  to="https://www.tiktok.com/@olympusrivieragreece"
                  target="_blank" 
                  rel="noopener noreferrer"
                >    
                  <TikTokSVG />
                </Link>
                <Link 
                  to="https://www.youtube.com/@OlympusRivieraGreece" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >    
                  <YouTubeSVG />
                </Link>

           </SocialMediaIcons>
        </Column>
          
       </Columns>

    </FooterContainer>
  )
}

export default Footer
